module.exports = __webpack_public_path__ + "static/media/126.c5604bd1.jpg";